import { useState } from "react";
import ArticleSection from "./components/ArticleSection";
import CookieBanner from "./components/CookieBanner";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import RelatedArticles from "./components/RelatedArticles";
import { useFullscreen } from "./hooks/useFullscreen";

export default function App() {
  const [showBanner, setShowBanner] = useState(true);

  useFullscreen(() => setShowBanner(false));

  return (
    <div>
      <Navbar />
      <Hero />
      <ArticleSection />
      <RelatedArticles />
      <Footer />
      <CookieBanner
        isVisible={showBanner}
        onClose={() => setShowBanner(false)}
      />
    </div>
  );
}
